import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.197 17.273a.508.508 0 0 1 .57.5V19a2 2 0 0 1-2 2h-3.6a2 2 0 0 1-2-2v-1.227c0-.303.267-.537.568-.5.776.093 2.188.244 3.232.244 1.043 0 2.455-.151 3.23-.244ZM11.967 2a6.967 6.967 0 1 1-.001 13.934 6.967 6.967 0 0 1 0-13.934Z" }, null, -1 /* HOISTED */)
  ])))
}
export default { render: render }